<script>
/**
 * ****************************************************************************
 * @description     :   Input Search Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash-uuid';
import { mapMutations, mapState } from 'vuex';
import PtjPopupBankAccount from '@/views/popupSearch/ptj_popup_bank_account';

/**
 * Import template
 */
import template from './template.html';
import helpers from '@/utils/helpers';

/**
 * Define content of input search component
 */
var PtjAnsInputSearch = {
    template: template,
    components: {
        PtjPopupBankAccount
    },
    props: {
        id: String,
        label: String,
        index: [String, Number],
        index2: Object,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        buttonClass: String,
        buttonId: String,
        isDisabledInput: {
            type: Boolean,
            default: false
        },
        isAlwaysEnable: {
            type: Boolean,
            default: false
        },
        isHidden: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: 'fas fa-search'
        },
        isShowClear: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: ''
        },
        value: String,
        modelValue: String,
        dataExtra: [String, Number],
        pageSearch: String,
        propertyForId: String,
        propertyForName: String,
        // popupName: String,
        isRequired: Boolean,
        isReadonly: {
            type: Boolean,
            default: true
        },
        isShowLabel: {
            type: Boolean,
            default: false
        },
        isShowFooter: {
            type: Boolean,
            default: false
        },
        isModalHeader: {
            type: Boolean,
            default: true
        },
        isDisabled: Boolean,
        isDisabledClear: Boolean,
        onChange: Function,
        onChangeInput: Function,
        size: String,
        maxLength: Number,
        isShowCloseButton: {
            type: Boolean,
            default: true
        },
        autoClose: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array
        },
        type: {
            type: String,
            default: 'number'
        },
        popupParent: String
    },
    emits: ['update:modelValue', 'onReferValueName', 'onReferValueOther'],
    data() {
        return {
            newId: '',
            show: true,
            // popup: '',
            modeDisabled: false,
            popupInputSearchOpening: [],
            isPopupVisible: {},
            popupName: '', // Tên popup hiện tại
            popup: null, // Component của modal
            initData: {} // Dữ liệu khởi tạo của popup
        };
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
        } else {
            this.newId = _.uuid();
        }
        if (
            ![
                'CUS_Login',
                'MNG_Login',
                'CUS_System901',
                'CUS_System902',
                'MNG_System901',
                'MNG_System902',
                'MNG_Order001',
                'MNG_System002',
                'MNG_System004',
                'MNG_Order004',
                'MNG_File001',
                'CUS_Order021',
                'CUS_Billing001',
                'CUS_Client003',
                'CUS_Delivery001'
            ].includes(this.$route.name)
        ) {
            this.modeDisabled = helpers.checkAuthorityMode(this.$route.name) && !this.isAlwaysEnable;
        }
        document.addEventListener('keydown', this.handleKeydown);
    },
    unmounted() {
        document.removeEventListener('keydown', this.handleKeydown);
    },
    computed: {
        ...mapState('app', ['footerModals']),
        lengthFooterModals() {
            return this.footerModals.length;
        },
        ...mapMutations('app', ['hideHeaderError']),
        vewValue() {
            if (this.modelValue) {
                return this.modelValue;
            }
            return '';
        },
        propertyId() {
            if (this.propertyForId) {
                return this.propertyForId;
            }
            return 'code';
        },
        propertyName() {
            if (this.propertyForName) {
                return this.propertyForName;
            }
            return 'name';
        },
        modalTitle() {
            switch (this.pageSearch) {
                case 'PtjPopupBankAccount':
                    return '銀行口座検索';
                default:
                    return '検索画面';
            }
        },
        realMaxLength() {
            return this.maxLength;
        },
        validateError() {
            let message = '';
            if (this.errors) {
                this.errors.forEach((item) => {
                    if (item.name == this.id) {
                        message = item.message;
                    }
                });
            }
            return message;
        }
    },
    methods: {
        // ...mapActions('app', ['hideHeaderError']),
        /**
         * update value for input search
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        updateInput(item) {
            if (this.onChange) {
                this.onChange(this.index, this.modelValue, item);
            } else {
                this.$emit('update:modelValue', item);
            }
        },
        /**
         * click button open popup
         * -----------------------------------------
         * @author : ManhND - 2024/09/10 - create
         * @params :
         * @access : private
         */
        openPopupInputSearch(inputSearchRef, btnOpenPopupRef) {
            localStorage.setItem('inputSearchFocus', inputSearchRef);
            localStorage.setItem('btnOpenPopup', btnOpenPopupRef);
            this.showPopupInputSearch(this.pageSearch, this.pageSearch, this.initData);
        },
        /**
         * show popup
         * -----------------------------------------
         * @author : ManhND - 2024/09/10 - create
         * @params :
         * @access : private
         */
        showPopupInputSearch(popupName, popupComponent, initData = {}) {
            this.isPopupVisible = { ...this.isPopupVisible, [popupName]: true };
            this.popupName = popupName;
            this.popup = popupComponent;
            this.initData = initData;
            //
            document.body.style.overflow = 'hidden';
            this.$nextTick(() => {
                const enabledInputsAndSelects = document.querySelectorAll(
                    `#${popupName}.popup-overlay .popup-wrapper .popup-body input:not([disabled]), #${popupName}.popup-overlay .popup-wrapper .popup-body select:not([disabled])`
                );
                if (enabledInputsAndSelects.length > 0) {
                    enabledInputsAndSelects[0].focus();
                }
            });
        },
        /**
         * close popup
         * -----------------------------------------
         * @author : ManhND - 2024/09/10 - create
         * @params :
         * @access : private
         */
        closePopupInputSearch(popupName) {
            this.isPopupVisible = {
                ...this.isPopupVisible,
                [popupName]: false
            };
            // focus input
            let inputFocusRef = localStorage.getItem('inputSearchFocus');
            let btnOpenPopupRef = localStorage.getItem('btnOpenPopup');
            let inputFocus = this.$refs[`${inputFocusRef}`];
            document.body.style.overflow = 'unset';
            if (inputFocus != undefined) {
                this.$refs[`${btnOpenPopupRef}`].blur();
                inputFocus.focus();
            }
        },
        handleKeydown(event) {
            if (event.keyCode === 27) {
                const popups = document.querySelectorAll('.popup-overlay');
                if (popups.length > 0) {
                    const lastPopup = popups[popups.length - 1];
                    const popupName = lastPopup.getAttribute('popup-name');
                    const excludedPopups = ['PopupMail', 'PopupChangePassword', 'PopupNotify'];
                    if (!excludedPopups.includes(popupName)) {
                        this.closePopupInputSearch(this.popupName);
                    }
                }
                // this.closeModal();
            }
        },
        /**
         * remove value for input search
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        clearInput() {
            if (this.onChange) {
                this.onChange(this.index2, this.modelValue, null);
            } else {
                this.$emit('update:modelValue', null);
            }
        },
        changeInput(e) {
            let value = e.target.value;
            if (!value.match('^[0-9]*$')) {
                e.target.value = '';
            } else {
                if (this.onChangeInput) {
                    this.onChangeInput(this.index, value);
                }
                this.$emit('update:modelValue', value);
            }
        },
        /**
         * get max lenght input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        getRealMaxLength() {
            return undefined;
        },
        onclickFooterButton(callback) {
            if (callback) {
                callback();
            }
            this.$refs['btnClose_' + this.newId]?.click();
        },
        inputKeydown(e) {
            if (this.type == 'number' || this.type == 'money' || this.type == 'measure' || this.type == 'postcode') {
                return this.inputOnlyNumber(e);
            }
            if (this.type == 'tel') {
                return this.inputOnlyTel(e);
            }
        },
        /**
         * event block key on input with type tel
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        inputOnlyTel(e) {
            if (
                !(
                    (!e.shiftKey && e.keyCode > 47 && e.keyCode < 58) ||
                    (!e.shiftKey && e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 107 ||
                    e.keyCode == 109 ||
                    (!e.shiftKey && e.keyCode == 189) ||
                    (e.shiftKey && e.keyCode == 57) ||
                    (e.shiftKey && e.keyCode == 48) ||
                    (e.shiftKey && e.keyCode == 187)
                )
            ) {
                event.preventDefault();
                return false;
            }
            return true;
        },
        /**
         * event block key on input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        inputOnlyNumber(e) {
            if (
                !(
                    (e.keyCode > 47 && e.keyCode < 58) ||
                    (e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 13
                ) ||
                (!this.isNegative && e.keyCode == 189) ||
                e.keyCode == 109
            ) {
                event.preventDefault();
                return false;
            }
            return true;
        },
        onReferModelValue(data) {
            this.$emit('update:modelValue', data);
        },
        onReferValueName(data) {
            this.$emit('onReferValueName', data);
        },
        onReferValueOther(data) {
            this.$emit('onReferValueOther', data);
        }
    }
};
export default PtjAnsInputSearch;
</script>
